import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import { getToken } from "@/utils/auth"; // get token from cookie
// import { getInfo } from "./api/user";

const whiteList = ["/login", "/auth-redirect"]; // no redirect whitelist

// eslint-disable-next-line space-before-function-paren
router.beforeEach(async (to, from, next) => {
  console.log(to);
  if (to.meta && to.meta.authorization) {
    debugger;
    const token = await getToken();
    console.log("token", token);
    if (token) {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0;
      if (hasRoles) {
        next();
      } else {
        try {
          const { roles } = await store.dispatch("user/getInfo");
          console.log(roles);
          next({ ...to, replace: true });
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch("user/resetToken");
          console.error(error);
          Message.error(error || "Has Error");
        }
      }
    } else {
      /* has no token*/
      if (whiteList.indexOf(to.path) !== -1) {
        // in the free login whitelist, go directly
        next();
      }
      // 没有token去登录
      else {
        this.userMgr.signIn();
      }
    }
  } else {
    next();
  }
});

router.afterEach(() => {
  // finish progress bar
});
